export default "__VITE_ASSET__j21YU36u__"